import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { IBanner } from "../../banners.types";
import { ApiRoutesBanners } from "../../constants";

export const requestGetBanners = async (
  params: GetListRequestParams
): Promise<GetListResponse<IBanner>> => {
  return await instance.get(ApiRoutesBanners.Banners, { params });
};
